import React, { useRef, useState } from "react";
import { ContentContainer } from "../../../components/layout";
import {
  Button,
  DownloadButton,
  LoadingComponent,
  Modal,
  Textarea,
  Textfield,
} from "../../../components/core";
import { gql, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import UnrecogTable from "./unrecogtable";
import {
  QUERY_SUSPICIOUS_NUMBERS,
  MUTATION_UPSERT_SUSPICIOUS_NUMBERS,
} from "../../../constants/graphql/drop-off-graphql";
import { Card } from "primereact/card";
import { Accordion, AccordionTab } from "primereact/accordion";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Row } from "primereact/row";
import { Tag } from "primereact/tag";
import { GET_AGENT_BY_ID } from "../../../constants/graphql/partner-agent-queries";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { Strings } from "../../../constants/strings";
import { useSelector } from "react-redux";

const SuspiciousCourierNumber = () => {
  const accessPermission = useSelector(
    (state) => state.accessPermissions.accessPermissions,
  );

  // local Variables
  const operatorId = JSON.parse(localStorage.getItem("user")).operator_id;
  const [suspiciousNumbers, setSuspiciousNumbers] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  const [suspiciousToAdd, setsuspiciousToAdd] = useState({
    id: "",
    warnings: "",
    severity: "",
    reason: "",
  });
  const AGENT_STATUS_LIST = {
    "-1": "Blocked",
    0: "Suspended",
    1: "Active",
  };
  const [confDialogVisible, setconfDialogVisible] = useState(false);
  const [validation, setValidation] = useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });

  const severity = [
    { value: 0, name: "low" },
    { value: 1, name: "medium" },
    { value: 2, name: "high" },
  ];

  const offensesData = [
    {
      id: 1,
      severity: "Low",
      firstOffense: "Warning",
      secondOffense: "Suspension for 3 days",
      thirdOffense: "Suspension for 2 weeks",
      fourthOffense: "Blocked",
    },
    {
      id: 2,
      severity: "Medium",
      firstOffense: "Warning",
      secondOffense: "Suspension for 2 weeks",
      thirdOffense: "Blocked",
      fourthOffense: "",
    },
    {
      id: 3,
      severity: "High",
      firstOffense: "Blocked",
      secondOffense: "",
      thirdOffense: "",
      fourthOffense: "",
    },
  ];

  //GraphQL queries
  const [QUERYSuspiciousNumbers, { data, loading }] = useLazyQuery(
    QUERY_SUSPICIOUS_NUMBERS,
    { fetchPolicy: "no-cache" },
  );

  const [validatePartnerAgent] = useLazyQuery(QUERY_SUSPICIOUS_NUMBERS);
  const [checkoutAgent, { data: agentData }] = useLazyQuery(GET_AGENT_BY_ID);

  const [add_suspicious] = useMutation(MUTATION_UPSERT_SUSPICIOUS_NUMBERS);

  useEffect(() => {
    if (data) {
      const tempArr = data.suspiciousAgents.map((o) => {
        const obj = { ...o };

        console.log({ obj, o, data });
        // Handle null or undefined firstName and lastName
        const firstName = o.firstName ?? "Unknown";
        const lastName = o.lastName ?? "Agent";
        obj.agentName = ` ${lastName}, ${firstName}`.trim();

        // Handle null or undefined mobile
        obj.mobile = o.mobile ?? "N/A";

        // Handle null or undefined agentStatus
        obj.agentStatusLabel = AGENT_STATUS_LIST[o.agentStatus] ?? "Unknown";

        obj.relatedSuspiciousMobiles = obj.relatedSuspiciousMobiles?.length;

        console.log({ o });
        if (o.agentStatusComment) {
          const comment = o.agentStatusComment.toLowerCase();
          if (comment.startsWith("suspend")) {
            obj.agentStatus = "Suspended";
          } else if (comment.startsWith("block")) {
            obj.agentStatus = "Blocked";
          }
        }

        // split offenses from severity
        obj.totalOffenses = o.recipientMobile.split("|")[0];
        obj.severity = o.recipientMobile.split("|")[1];
        return obj;
      });

      setSuspiciousNumbers(tempArr);
      setisLoading(false);
    }
  }, [data]);

  const handleSearch = () => {
    setisLoading(true);
    setIsClicked(true);

    QUERYSuspiciousNumbers().then((r) => {
      setisLoading(false);
    });
  };
  // checks if agent to be added is a registered MBOX agent
  const checkAgentExisting = () => {
    return checkoutAgent({
      variables: {
        agentId: suspiciousToAdd.id,
      },
    })
      .then((response) => {
        return response.data.getAgentById?.length > 0;
      })
      .catch((error) => {
        console.error({ error });
        return false; // Return false on error to prevent adding
      });
  };

  // checks if agent to be added is already tagged as suspicious before
  // THIS ONLY VALIDATES IF AGENT ID EXIXSTS, NOT THE MOBILE NUMBER
  // this is to avoid multiple entry
  // this assumes a 1:1 relationship that one agent can be tagged only with one severity and offnese
  const isAgentFlaggedBefore = async () => {
    try {
      const response = await validatePartnerAgent({
        variables: {
          partnerAgentId: suspiciousToAdd.id,
        },
      });
      return response.data.suspiciousAgents?.length > 0;
    } catch (error) {
      console.error({ error });
      return false;
    }
  };

  const validateFields = () => {
    if (
      suspiciousToAdd.id === "" ||
      suspiciousToAdd.severity === "" ||
      suspiciousToAdd.warnings === ""
    ) {
      console.log("hello");
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: Strings.popup_error_title,
        message: Strings.popup_error_message_empty_field,
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
    } else {
      handleAdd();
    }
  };

  const handleAdd = async () => {
    const agentExists = await checkAgentExisting();
    const agentFlaggedBefore = await isAgentFlaggedBefore();

    if (agentExists) {
      if (!agentFlaggedBefore) {
        // Agent exists and hasn't been flagged before, proceed to add
        add_suspicious({
          variables: {
            input: {
              partnerAgentId: suspiciousToAdd.id,
              recipientMobile:
                suspiciousToAdd.warnings + "|" + suspiciousToAdd.severity,
              reason: suspiciousToAdd.reason,
            },
          },
        })
          .then((data) => {
            setValidation({
              content: "Request accepted successfully",
              title: "Success",
              visibility: true,
              forError: false,
            });
            handleSearch();
            setconfDialogVisible(false);
          })
          .catch((error) => {
            console.error(error);
            setValidation({
              content: error.toString(),
              title: "Error",
              visibility: true,
              forError: true,
            });
            handleSearch();
            setconfDialogVisible(false);
          });
      } else {
        // Agent has already been flagged
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
          title: "Error",
          message: "Agent has already been flagged before",
          open: true,
          forError: true,
          actions: (
            <Button
              onClick={() =>
                setValidation((prev) => ({ ...prev, open: false }))
              }
              value={"Ok"}
              className={"p-2 w-full"}
            />
          ),
        });
      }
    } else {
      // Agent ID does not exist
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Error",
        message: "Agent ID does not exist. Please recheck the agent ID",
        open: true,
        // forError: true,
        actions: (
          <Button
            onClick={() => setValidation((prev) => ({ ...prev, open: false }))}
            value={"Ok"}
            className={"p-2 w-full"}
          />
        ),
      });
    }
  };

  const handleEdit = ({ id, partnerAgentId, recipientMobile, reason }) => {
    add_suspicious({
      variables: {
        input: {
          partnerAgentSuspiciousId: id,
          partnerAgentId: partnerAgentId,
          recipientMobile: recipientMobile,
          reason: reason,
        },
      },
    })
      .then((data) => {
        setValidation({
          content: "Request accepted successfully",
          title: "Success",
          visibility: true,
          forError: false,
        });
        handleSearch();
        setconfDialogVisible(false);
      })
      .catch((e) => {
        setValidation({
          content: e.toString(),
          title: "Error",
          visibility: true,
          forError: true,
        });
        handleSearch();
        setconfDialogVisible(false);
      });
  };

  const dt = useRef(null);

  const SeverityTag = ({ severity }) => {
    const severityColors = {
      High: "danger",
      Medium: "warning",
      Low: "info",
    };

    return (
      <Tag value={severity} severity={severityColors[severity] || "info"} />
    );
  };

  console.log({ suspiciousToAdd });
  return (
    <ContentContainer containerTitle={"Suspicious Courier Tagging"}>
      <div className="flex flex-row mt-[20px]">
        <Button
          value={"SEARCH"}
          onClick={(event) => {
            setisLoading(true);
            handleSearch(event, data);
          }}
          className={"w-40 h-8 "}
        />
        <p className="w-[30px]"></p>
      </div>

      {isClicked && (
        <>
          <Accordion className="py-8" multiple activeIndex={[1]}>
            <AccordionTab header="Suspicious Courier Legend">
              {
                //LEGEND
              }
              {/* <div>
						<p className="font-bold mt-[50px]">LEGEND: </p>
						<img
							src="/assets/images/Severity Legend.png"
							className="w-[400px]"
						/>
					</div> */}
              <Card className="bg-primary-primaryYellow">
                <DataTable value={offensesData}>
                  <Column
                    header="Severity"
                    body={(rowData) => (
                      <SeverityTag severity={rowData.severity} />
                    )}
                  ></Column>
                  <Column header="1st Offense" field="firstOffense"></Column>
                  <Column header="2nd Offense" field="secondOffense"></Column>
                  <Column header="3rd Offense" field="thirdOffense"></Column>
                  <Column header="4th Offense" field="fourthOffense"></Column>
                </DataTable>
              </Card>
            </AccordionTab>

            <AccordionTab header="Suspicious Couriers">
              <Card>
                {isLoading ? (
                  <LoadingComponent />
                ) : (
                  <>
                    {suspiciousNumbers.length > 0 && (
                      <div>
                        <div className="flex justify-between items-center pb-5">
                          <div className="flex flex-row gap-1">
                            <p>Total Result: </p>
                            <p className="font-bold">
                              {suspiciousNumbers.length}
                            </p>
                          </div>

                          <Button
                            value={"ADD"}
                            onClick={(event) => {
                              setconfDialogVisible(true);
                            }}
                            className={`w-40 h-8 bg-primary-primaryYellow shadow-md ${
                              accessPermission.suspiciousCourierTagging === 1 ||
                              accessPermission.suspiciousCourierTagging === "1"
                                ? "hidden"
                                : ""
                            }`}
                          />
                        </div>
                        <DownloadButton
                          dt={dt}
                          id={"Suspicious Courier Tagging"}
                        />
                        <div id="Suspicious Courier Tagging">
                          <UnrecogTable
                            handleEdit={handleEdit}
                            headers={[
                              {
                                header_name: "Agent",
                                header_key: "agentName",
                                tag: "1",
                              },
                              {
                                header_name: "Mobile Number",
                                header_key: "agentMobile",
                              },
                              {
                                header_name: "Agent Status",
                                header_key: "agentStatus",
                              },
                              {
                                header_name: "# of Offenses",
                                header_key: "totalOffenses",
                                tag: "occurence",
                              },
                              {
                                header_name: "Severity",
                                header_key: "severity",
                                tag: "severity",
                              },
                              {
                                header_name: "# of related numbers",
                                header_key: "relatedSuspiciousMobiles",
                                tag: "relatedSuspiciousMobiles",
                              },
                              {
                                header_name: "Remarks",
                                header_key: "reason",
                              },
                              {
                                header_name: "Last Updated",
                                header_key: "updatedAt",
                              },
                              {
                                header_name: "",
                                header_key: "action",
                              },
                            ]}
                            items={suspiciousNumbers}
                            dt={dt}
                          />
                        </div>
                      </div>
                    )}
                  </>
                )}
              </Card>
            </AccordionTab>
          </Accordion>
        </>
      )}
      {/* {isLoading && <LoadingComponent />} */}

      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />

      <Dialog
        visible={confDialogVisible}
        closeOnEscape={false}
        onHide={() => setconfDialogVisible(false)}
        headerClassName="p-1 m-0"
        className="w-[550px]"
      >
        <div className="flex flex-col justify-center items-start">
          <p className="font-bold text-[16px] mb-[20px] w-full text-center">
            Add Suspicious Number
          </p>

          <div className="grid grid-cols-6 gap-1 items-center w-full mb-2">
            <p className="text-[14px] col-span-2">Agent ID:</p>
            <InputText
              type="text"
              value={suspiciousToAdd.id}
              onChange={(e) => {
                setsuspiciousToAdd((prev) => ({
                  ...prev,
                  id: e.target.value,
                }));
              }}
              maxLength={10}
              placeholder={`Enter Agent Id`}
              className="appearance-none col-span-4"
              pt={{
                root: {
                  className: "border border-gray-200 p-1 h-10 rounded-md",
                },
              }}
            />
          </div>

          <div className="grid grid-cols-6 gap-1 items-center w-full mb-2">
            <p className="text-[14px] col-span-2"># of Offenses:</p>
            <InputText
              type={"int"}
              keyfilter={"int"}
              value={suspiciousToAdd.warnings}
              min={0}
              onChange={(e) => {
                setsuspiciousToAdd((prev) => ({
                  ...prev,
                  warnings: e.target.value,
                }));
              }}
              maxLength={3}
              placeholder={`1`}
              className="appearance-none col-span-4"
              pt={{
                root: {
                  className: "border border-gray-200 p-1 h-10 rounded-md",
                },
              }}
            />
          </div>

          <div className="grid grid-cols-6 gap-1 items-center w-full mb-2">
            <p className="text-[14px] col-span-2">Severity:</p>
            <Dropdown
              value={suspiciousToAdd.severity}
              onChange={(e) => {
                setsuspiciousToAdd((prev) => ({
                  ...prev,
                  severity: e.value,
                }));
              }}
              options={severity}
              optionLabel="name"
              placeholder="Choose severity"
              className="col-span-4 border h-10  items-center"
              style={{ borderColor: "#e2e8f0" }}
            />
          </div>

          <div className="grid grid-cols-6 gap-1 items-center w-full mb-2">
            <p className="text-[14px] col-span-2">Remarks:</p>
            <Textarea
              type="text"
              value={suspiciousToAdd.reason}
              onChange={(e) => {
                setsuspiciousToAdd((prev) => ({
                  ...prev,
                  reason: e.target.value,
                }));
              }}
              maxLength={1000}
              placeholder={`Enter Reason`}
              classNameParent={" grid col-span-4"}
              className="appearance-none "
            />
          </div>
          {/* test push */}
          <div className="flex flex-row gap-2 mt-[20px] justify-center w-full">
            {/* <div className="flex flex-row items-center w-full"> */}
            <Button
              value={"Cancel"}
              onClick={(event) => {
                setconfDialogVisible(false);
              }}
              className={"w-40 h-8 mx-5 my-1 bg-secondary-buttonGray"}
            />
            <Button
              value={"ADD"}
              onClick={(event) => {
                // handleAdd();
                validateFields();
              }}
              className={"w-40 h-8 mx-5 my-1 bg-primary-primaryYellow"}
            />
          </div>
        </div>
      </Dialog>
    </ContentContainer>
  );
};

export default SuspiciousCourierNumber;
